// Email.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Email = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "mailto:cala.millor@iberostar.com",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-envelope icon-space" />
        email
      </button>
      {showModal && (
        <LanguageModal
          title="cala.millor@iberostar.com"
          icon="bi bi-envelope"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Email;
